const env = import.meta.env.MODE || "development";
function getEnvVariable(key: string, required?: true): string;
function getEnvVariable(key: string, required?: false): string | undefined;
function getEnvVariable(key: string, required = true): string | undefined {
  const value = import.meta.env[key] as string | undefined;
  if (required && value === undefined) {
    throw new Error(`Missing environment variable: ${key}`);
  }

  return value;
}

export const Config = {
  ENV: env,
  API_URL: getEnvVariable("VITE_ENV_API_URL"),
  VAPID_PUBLIC_KEY: getEnvVariable("VITE_ENV_VAPID_PUBLIC_KEY", false),
  PATCH_PILOT_API_KEY: getEnvVariable("VITE_ENV_PATCH_PILOT_API_KEY"),
  PATCH_PILOT_API_URL: getEnvVariable("VITE_ENV_PATCH_PILOT_API_URL"),
  SENTRY_DSN: getEnvVariable("VITE_ENV_SENTRY_DSN", false),
};
